import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getShopifyShopDetails = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shopify/shop-details`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}